import React from 'react';
import {Box, Input as NativeInput, FormControl} from 'native-base';
import {FieldError, useController, UseControllerProps} from 'react-hook-form';
import {defaultProps} from '../constants';
import {message} from '../../../utils/messages';

interface Props extends UseControllerProps<any> {
  label: string;
  error: FieldError | undefined;
  type?: 'email' | 'number' | 'default' | 'text';
  disabled?: boolean;
  width?: string;
}

const TextInput = (props: Props) => {
  const {
    label,
    error,
    type: typeInput,
    control,
    name,
    rules,
    defaultValue,
    disabled,
    width,
  } = props;

  const {field} = useController({
    control,
    defaultValue: defaultValue ?? '',
    name,
    rules,
  });

  const getErrorMessage = () => {
    return error != null ? message(error.message as string) : '';
  };

  const handleChangeText = (value: string) => {
    field.onChange(value);
  };

  return (
    <Box width={width ? width : '100%'} marginBottom={5}>
      <FormControl isRequired isInvalid={error != null}>
        <FormControl.Label>{message(label)}</FormControl.Label>
        {typeInput === 'email' && (
          <NativeInput
            {...defaultProps}
            keyboardType="email-address"
            value={field.value}
            onChangeText={handleChangeText}
            isDisabled={disabled}
          />
        )}
        {(typeInput == null || typeInput === 'default') && (
          <NativeInput
            {...defaultProps}
            value={field.value}
            onChangeText={handleChangeText}
            isDisabled={disabled}
          />
        )}
        {typeInput === 'number' && (
          <NativeInput
            {...defaultProps}
            value={field.value}
            onChangeText={handleChangeText}
            isDisabled={disabled}
            keyboardType="number-pad"
          />
        )}
        <FormControl.ErrorMessage mt="0">
          {getErrorMessage()}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default TextInput;
